var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoReplacement(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7679 8.81072C30.9223 7.10805 29.0892 6 27 6C25.0177 6 23.2132 7.17484 22.3393 8.91661L6.53568 40.4166C6.18377 41.1179 6 41.9015 6 42.6968C6 45.6137 8.41071 48 11.3033 48H42.6967C45.5893 48 48 45.6137 48 42.6968C48 41.9545 47.8343 41.1616 47.4643 40.4166L31.7679 8.81072ZM24.5 32V17H29.5V32H24.5ZM27 42C28.3807 42 29.5 40.8807 29.5 39.5C29.5 38.1193 28.3807 37 27 37C25.6193 37 24.5 38.1193 24.5 39.5C24.5 40.8807 25.6193 42 27 42Z",
    fill: "#F75F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoReplacement);
export default __webpack_public_path__ + "static/media/ico_replacement.af416ef7768ea7e30375420a627a43f0.svg";
export { ForwardRef as ReactComponent };